import * as actionTypes from "../../constants/actionTypes";
import { getShop, getShopIds, getShops } from "../../api/shop";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateShops = () => {
  return {
    type: actionTypes.INVALIDATE_SHOPS_DATA
  };
};

const loadShop = (clientConfig, shopId) => {
  return {
    type: actionTypes.LOAD_SHOP_DATA,
    promise: getShop(clientConfig, shopId)
  };
};

const loadShopPhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_SHOP_PHONE_OFFER_IDS_DATA,
    promise: getShopIds(clientConfig, OFFER_TYPES.phoneOffer, dataStatus)
  };
};

const loadShopPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_SHOP_PROPOSITION_IDS_DATA,
    promise: getShopIds(clientConfig, OFFER_TYPES.proposition, dataStatus)
  };
};

const loadShopSimOnlyIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_SHOP_SIM_ONLY_IDS_DATA,
    promise: getShopIds(clientConfig, OFFER_TYPES.simOnly, dataStatus)
  };
};

const loadShops = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_SHOPS_DATA,
    promise: getShops(clientConfig, dataStatus)
  };
};

export {
  invalidateShops,
  loadShop,
  loadShopPhoneOfferIds,
  loadShopPropositionIds,
  loadShopSimOnlyIds,
  loadShops
};
